<!-- eslint-disable -->
<template>
  <div class="dispatchWhiteControl">
    <div class="dispatchWhiteControlSwitch">
      <el-switch v-model="form.TRANSPORT_CONTROL.flag" active-color="#059E84" inactive-color="#D9DBDE" @change="toggleShow" />
      <span class="switch_tips">开启后仅能调度名单中的司机和车辆</span>
    </div>
    <template v-if="form.TRANSPORT_CONTROL.flag">
      <el-row :gutter="20" v-for="(domain, index) in form.TRANSPORT_CONTROL.rules" :key="domain.key">
        <el-col :span="4">
          <el-form-item
            label="运营项目"
            :prop="'TRANSPORT_CONTROL.rules.' + index + '.projectIds'"
            :rules="{ required: false, message: '请选择' }"
          >
            <el-select
              v-model="domain.projectIds"
              filterable
              multiple
              placeholder="请选择项目"
              @change="(val) => changeProject(val, index)"
            >
              <!-- :disabled="!!(domain.carType && chooseCarType[domain.carType] && chooseCarType[domain.carType].includes(t.value))" -->
              <el-option v-for="t in projectOptions" :key="t.value" :label="t.label" :value="t.value" />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item
            label="调度租户"
            :prop="'TRANSPORT_CONTROL.rules.' + index + '.tenantList'"
            :rules="{ required: true, message: '请选择' }"
            >
            <ShowText
              :list="formatPureText(domain.tenantList, 'tenantName')"
              @choose="handlerTenantScope(index)"
              :disabled="isDetail"
              prefix="租户"
              width="100%"
            />
            <!-- <el-input @click.native.prevent="handlerTenantScope"></el-input> -->
          </el-form-item></el-col
        >
        <el-col :span="6">
          <el-form-item
            label="选择司机"
            :prop="'TRANSPORT_CONTROL.rules.' + index + '.driverList'"
            :rules="{ required: false, message: '请选择' }"
          >
            <ShowText
              :list="formatPureText(domain.driverList, 'driverName')"
              @choose="handlerDriverScope(index)"
              :disabled="isDetail"
              prefix="司机"
              width="100%"
            />
            <!-- <el-input @click.native.prevent="handlerDriverScope"></el-input> -->
          </el-form-item></el-col
        >
        <el-col :span="6">
          <el-form-item
            label="选择车辆"
            :prop="'TRANSPORT_CONTROL.rules.' + index + '.licensePlates'"
            :rules="{ required: false, message: '请选择' }"
          >
            <ShowText
              :list="domain.licensePlates"
              @choose="handlerCarScope(index)"
              :disabled="isDetail"
              prefix="车辆"
              width="100%"
              placement="left"
            />
            <!-- <el-input @click.native.prevent="handlerCarScope"></el-input> -->
          </el-form-item></el-col
        >
        <el-col :span="2">
          <el-form-item label="" prop="carScope" label-width="0">
            <span class="c-red" @click="handleDelete(index)" v-if="form.TRANSPORT_CONTROL.rules.length > 1">删除</span>
            <!-- <i
              class="el-icon-error clear_icon"
              @click="handleDelete(index)"
              v-if="form.TRANSPORT_CONTROL.rules.length > 1"
            /> -->
          </el-form-item>
        </el-col>
      </el-row>
      <el-col :span="24">
        <div class="add_btn flex flex-center" @click="handleAddOrCondition">
          <span>
            <i class="el-icon-plus" />
            添 加
          </span>
        </div>
      </el-col>
    </template>
    <!-- 选择车辆 -->
    <SelectCar ref="selectCarRefs" :pure="isDetail" @confirm="handlerCarConfirm" />
    <!-- 选择司机 -->
    <SelectDriver ref="selectDriverRefs" :pure="isDetail" @confirm="handlerDriverConfirm" />
    <!-- 选择租户 -->
    <ChooseRentDrawer ref="chooseRentDrawerRef" :pure="isDetail" :is-init="true" @getCheckNodes="getCheckNodes" />
  </div>
</template>
<script>
import SelectCar from '@/views/capacityManagement/capacityBlacklist/form/components/SelectCar.vue';
import SelectDriver from '@/views/capacityManagement/capacityBlacklist/form/components/SelectDriver.vue';
import ChooseRentDrawer from '@/components/ChooseRentDrawer/index.vue';
import ShowText from '@/views/capacityManagement/capacityBlacklist/form/components/ShowText.vue';
import { cloneDeep } from 'lodash';

/* eslint-disable */
export default {
  name: 'DispatchWhiteControl',
  components: {
    SelectCar,
    SelectDriver,
    ChooseRentDrawer,
    ShowText,
  },
  props: {
    form: {
      type: Object,
      default: () => {},
    },
    projectOptions: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    licensePlatesOrigin() {
      const { currentIndex, form } = this;
      if (currentIndex !== null) {
        return (form.TRANSPORT_CONTROL.rules[currentIndex]['licensePlates'] || [])?.map((item) => ({
          label: item,
          value: item,
        }));
      }
      return [];
    },
    driverListOrigin() {
      const { currentIndex, form } = this;
      if (currentIndex !== null) {
        return (form.TRANSPORT_CONTROL.rules[currentIndex]['driverList'] || [])?.map((item) => ({
          ...item,
          value: item?.registerCode,
        }));
      }
      return [];
    },
  },
  data() {
    return {
      currentIndex: null,
      // projectOptions: [
      //   {
      //     value: '1',
      //     label: '项目1',
      //     projectId: '1',
      //     projectName: '项目1',
      //   },
      // ],
      isDetail: false,
    };
  },
  methods: {
    toggleShow(){
      const existData = this.form?.TRANSPORT_CONTROL?.rules || [];
      if (existData?.length === 0) {
        this.handleAddOrCondition();
      }
    },
    formatPureText(list, filed) {
      return (list || [])?.map((item) => item[filed]);
    },
    handleAddOrCondition() {
      const list = this.form.TRANSPORT_CONTROL.rules;
      list.push({
        projectIds: undefined,
        projectList: [],
        tenantList: [],
        driverList: [],
        licensePlates: [],
      });
      this.$set(this.form.TRANSPORT_CONTROL, 'rules', list);
    },
    handleDelete(index) {
      this.form.TRANSPORT_CONTROL.rules.splice(index, 1);
    },
    changeProject(val, index) {
      if (val) {
        const tt = this.form.TRANSPORT_CONTROL.rules[index];
        const pids = (Array.isArray(val) ? val : [val])?.map((t) => String(t));
        const projectList = this.projectOptions.filter((t) => pids?.includes(String(t.value)));
        this.form.TRANSPORT_CONTROL.rules.splice(index, 1, { ...tt, projectList });
      } else {
        this.form.TRANSPORT_CONTROL.rules.splice(index, 1, { ...tt, projectList: [] });
      }
      // this.emitValidForm();
    },
    emitValidForm() {
      setTimeout(() => {
        this.$emit('valid');
      }, 100);
    },
    // 设置租户相关
    formattTenantItem(item) {
      return {
        tenantName: item.tenantName,
        tenantId: item.tenantCode || item.tenantId,
        tenantCode: item.tenantCode || item.tenantId,
      };
    },
    getCheckNodes(list) {
      const index = this.currentIndex;
      const tt = this.form.TRANSPORT_CONTROL.rules[index];
      this.form.TRANSPORT_CONTROL.rules.splice(index, 1, {
        ...tt,
        tenantList: (list || [])?.map(this.formattTenantItem),
      });
      this.emitValidForm();
    },
    handlerCarConfirm(list) {
      const index = this.currentIndex;
      const licensePlates = list?.map((item) => item.value);
      const tt = this.form.TRANSPORT_CONTROL.rules[index];
      this.form.TRANSPORT_CONTROL.rules.splice(index, 1, { ...tt, licensePlates });
    },
    handlerDriverConfirm(list) {
      const index = this.currentIndex;
      const tt = this.form.TRANSPORT_CONTROL.rules[index];
      this.form.TRANSPORT_CONTROL.rules.splice(index, 1, { ...tt, driverList: list });
    },
    handlerTenantScope(index) {
      this.currentIndex = index;
      const tt = cloneDeep(this.form.TRANSPORT_CONTROL.rules[index]['tenantList']);
      this.$refs.chooseRentDrawerRef.show(tt?.map(this.formattTenantItem));
    },
    handlerDriverScope(index) {
      this.currentIndex = index;
      this.$refs.selectDriverRefs.show({
        selected: this.driverListOrigin,
      });
    },
    handlerCarScope(index) {
      this.currentIndex = index;
      this.$refs.selectCarRefs.show({
        selected: this.licensePlatesOrigin,
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.dispatchWhiteControl {
  width: 100%;
  box-sizing: border-box;
  margin-bottom: 80px;
  .add_btn {
    cursor: pointer;
    height: 38px;
    border: 1px dashed #b3b7be;
    font-size: 14px;
    .el-icon-plus {
      margin-right: 10px;
    }
    &:hover {
      border-color: #51cda6;
      color: #51cda6;
    }
    &:focus {
      border-color: #059366;
      color: #059366;
    }
  }
  .dispatchWhiteControlSwitch {
    margin-bottom: 12px;
  }
  .switch_tips {
    margin-left: 12px;
    font-size: 13px;
    color: #808792;
  }
  .clear_icon {
    cursor: pointer;
    margin-top: 40px;
  }
  .c-red {
    color: red;
    cursor: pointer;
    display: inline-block;
    height: 64px;
    line-height: 64px;
    // margin-top: 40px;
  }
}
</style>
